export function blurNumberOnWheel(event) {
  const field = event.currentTarget
  if (!field || field.type !== 'number') return
  if (document.activeElement === field) {
    event.preventDefault()
    field.blur()
  }
}
